import { appModulesG4Ar } from './golf4App.ar.js';
// Arabisch (ar), modulesApp: zelfde vorm als modulesApp.nl.ts. Instellingen · Modules en brengen
// en halen in de agenda ("يوصل" = brengen, "يُرجع" = halen).
export const appModulesAr = {
    ...appModulesG4Ar,
    title: 'الوحدات',
    intro: 'اختاروا الأقسام التي تستخدمونها. الإيقاف لا يحذف شيئًا: عندما تعيد تشغيل قسم، تجد كل شيء كما كان.',
    settingsBody: 'شغّل الأقسام أو أوقفها، مثل التوصيل والإرجاع',
    on: 'مفعّل',
    off: 'مطفأ',
    dependsOn: 'يعمل فقط إذا كان {names} مفعّلًا.',
    offBecause: 'مطفأ ({names} مطفأ)',
    exampleA: 'مريم',
    exampleB: 'يوسف',
    holidaysIslamic: 'وأيضًا عيد الفطر وعيد الأضحى حسب تقاليدكم.',
    blockedBy: 'مطفأ لأن {names} مطفأ.',
    alsoOff: 'سيتوقف معه أيضًا {names}.',
    notInPlan: 'غير مشمول في اشتراككم.',
    settings: 'الإعدادات',
    /** WP3: toegankelijke naam van het tandwiel bij een module. */
    settingsOf: 'إعدادات {name}',
    // Golf 6b (0043): modules die niet bij de soort huishouden passen, en de soort zelf.
    showAll: 'عرض كل الوحدات',
    showFewer: 'ما يناسبنا فقط',
    hiddenNote: 'الأجزاء التي لا تناسب نوع أسرتكم مخفية.',
    typeLine: 'نوع الأسرة: {name}',
    typeChange: 'تغيير',
    toastOn: '{name} مفعّل',
    toastOff: '{name} مطفأ. لم يُحذف شيء.',
    toastOption: 'تم الحفظ',
    optionNeeds: 'يعمل إذا كان {name} مفعّلًا.',
    onlyParents: 'يستطيع أحد الوالدين فقط تغيير هذا.',
    kioskNote: 'يتكيّف الجهاز اللوحي خلال ثوانٍ.',
    groups: {
        agenda: 'التقويم والتنقل',
        home: 'البيت والعيش معًا',
        personal: 'شخصي',
        faith: 'الإيمان والتقاليد',
        board: 'اللوحة والتطبيق',
        care: 'الرعاية والعائلة',
    },
    groupCount: '{on} من {total} مفعّلة',
    search: 'ابحث عن وحدة',
    searchNone: 'لم نجد وحدة باسم «{q}».',
    options: 'الخيارات ({n})',
    offTitle: '{name} مطفأ',
    offBody: 'هذا القسم مطفأ لعائلتكم. لم يُحذف شيء.',
    offBodyChild: 'هذا القسم مطفأ. اطلب من بابا أو ماما تشغيله.',
    offAction: 'إلى الوحدات',
    rides: {
        dropoff: 'يوصل: {name}',
        pickup: 'يُرجع: {name}',
        both: 'يوصل ويُرجع: {name}',
        whoDropoff: 'من يوصل؟',
        whoPickup: 'من يُرجع؟',
        travel: '{minutes} د في الطريق',
        travelWho: 'يقود: {name} · {minutes} د',
        /** 0056: smal blokje ná de afspraak (de weg terug). */
        travelBack: '{minutes} د للعودة',
    },
};
//# sourceMappingURL=modulesApp.ar.js.map